import { Box } from '@material-ui/core'
import { Card, ContactLink, ContentBlock } from '../components'
import { formattedEstimate } from '../../ShippingEstimate.utils'

interface ShippingInfoCardProps {
  daysFromDueDate: number
}

export default function ShippingInfoCard({
  daysFromDueDate,
}: ShippingInfoCardProps) {
  const estimate = formattedEstimate(daysFromDueDate)

  return (
    <Card>
      <ContentBlock title="When will my pump ship?">
        <Box mb={2}>
          Your insurance plan determines when we can ship your pump. Once we
          receive all requirements, you can expect your pump to ship {estimate}{' '}
          your due date. If your due date changes and you need to receive your
          pump sooner than estimated, please reach out to <ContactLink />.{' '}
        </Box>
        You'll get shipping and delivery updates by email.
      </ContentBlock>
    </Card>
  )
}
